// Recovered compiled webpack factory 78817. Edit this function expression; run npm run build.
(e, t, r) => {
  "use strict";
  (r.r(t), r.d(t, { RockScene: () => P }));
  var n = r(95155),
    a = r(12115),
    s = r(15239),
    i = r(65025),
    l = r(27122),
    o = r(41416);
  let c = null,
    d = null,
    u = null,
    m = 0,
    h = null,
    p = 0,
    f = 0,
    v = !1;
  async function b(e, t) {
    if (h) throw Error(`Rock scene unavailable: ${h}`);
    let r = c ?? (await (d ??= y()));
    if (h || c !== r) throw Error("Rock scene unavailable");
    if (u && u !== e) {
      let e = u;
      ((u = null), e.onLost("taken"));
    }
    return ((u = e), r.canvas.parentElement !== t && t.appendChild(r.canvas), r);
  }
  function g(e) {
    u === e && ((u = null), null == c || c.canvas.remove());
  }
  function x(e, t) {
    if (h) return;
    ((h = e), w(e, t));
    let r = u;
    u = null;
    let n = c;
    ((c = null),
      (d = null),
      null == n || n.renderer.destroy(),
      null == n || n.canvas.remove(),
      null == r || r.onLost(e));
  }
  async function y() {
    let e,
      [{ createRenderer: t }, n, { analyseMediaElement: a }, { createEmissionSampler: s }] =
        await Promise.all([
          Promise.all([
            r.e(1831),
            r.e(1748),
            r.e(6641),
            r.e(4664),
            r.e(5210),
            r.e(3527),
            r.e(2696),
            r.e(4241),
            r.e(1797),
            r.e(6091),
            r.e(4189),
            r.e(1788),
            r.e(1987),
          ]).then(r.bind(r, 91987)),
          Promise.all([r.e(1797), r.e(6091), r.e(9168), r.e(8476)]).then(r.bind(r, 78476)),
          r.e(9930).then(r.bind(r, 59930)),
          r.e(1942).then(r.bind(r, 51942)),
        ]);
    if (0 === m || h) throw Error("Rock scene unavailable");
    (v ||
      "undefined" == typeof document ||
      ((v = !0),
      document.addEventListener("visibilitychange", () => {
        document.hidden && (f = performance.now());
      })),
      (p = performance.now()));
    let i = document.createElement("canvas");
    ((i.className = "absolute inset-0 h-full w-full"),
      i.setAttribute("aria-hidden", "true"),
      i.addEventListener("webglcontextlost", () => x("context_lost")));
    try {
      e = t(i, {
        silent: !0,
        modelUrls: { [n.ROCK_MODEL]: `${n.ROCK_ASSETS}/iphone.glb` },
        finishTextureUrls: n.ROCK_FINISH_URLS,
        pmremSupersample: !1,
      });
    } catch (e) {
      throw (h || ((h = "start_failed"), (0, o.w)(e, "marketing_rock")), e);
    }
    let l = new Map();
    try {
      let t = n.rockSceneParams();
      await Promise.all([
        e.loadMockupModel(n.ROCK_MODEL),
        e.prepareEnvironment(t.environment),
        e.whenPostReady(),
      ]);
    } catch (t) {
      throw (e.destroy(), i.remove(), h || ((h = "start_failed"), w("start_failed", t)), t);
    }
    if (0 === m || h) throw (e.destroy(), i.remove(), Error("Rock scene unavailable"));
    return (c = {
      renderer: e,
      canvas: i,
      createParams: n.rockSceneParams,
      tilt: n.rockTilt,
      analyse: a,
      emission: s(),
      loadImage: function (e) {
        let t = l.get(e);
        if (t) return t;
        let r = new window.Image();
        r.src = e.startsWith("/") ? e : `/marketing/rock-scene/v1/${e}.webp`;
        let n = r
          .decode()
          .then(() => r)
          .catch((t) => {
            throw (l.delete(e), t);
          });
        return (l.set(e, n), n);
      },
    });
  }
  function w(e, t) {
    let r = performance.now(),
      n = (e) => Math.round(e / 100) / 10;
    l.wd("marketing.rock_scene.unavailable", {
      level: "warning",
      fingerprint: ["marketing-rock-scene-unavailable", e],
      tags: {
        "um.signal": "marketing.rock_scene.unavailable",
        "scene.failure": e,
        "scene.page_visibility": document.visibilityState,
      },
      extra: {
        error: t instanceof Error ? t.message : void 0 === t ? void 0 : String(t),
        paperShaderContexts: document.querySelectorAll("[data-paper-shader] canvas").length,
        deviceMemoryGb: navigator.deviceMemory ?? null,
        devicePixelRatio: window.devicePixelRatio,
        secondsSinceStart: p ? n(r - p) : null,
        secondsSinceLastHidden: f ? n(r - f) : null,
      },
    });
  }
  let k = "/marketing/rock-scene/v1",
    j = {
      background: [
        { id: "rocks", label: "Mountains", file: "background", screen: "opal-screen", app: "Opal" },
        {
          id: "landscape",
          label: "Sky",
          file: "landscape",
          screen: "wallet-screen",
          app: "Wallet",
        },
        { id: "glaze", label: "Raycast", file: "glaze", screen: "camera-screen", app: "Camera" },
        { id: "room", label: "Room", file: "room", screen: "ultrahuman-screen", app: "Ultrahuman" },
      ],
      finish: [
        { id: "black", label: "Black", color: "#282828" },
        { id: "burgundy", label: "Burgundy", color: "#68464b" },
        { id: "glacier", label: "Glacier", color: "#b5c8ed" },
        { id: "silver", label: "Silver", color: "#e3e3e0" },
      ],
    },
    N = "rocks",
    _ = "room",
    E = { background: N, finish: "black" };
  function M(e) {
    let t = e ? N : _;
    return j.background.find((e) => e.id === t);
  }
  function P(e) {
    let { variant: t = "showcase" } = e,
      r = "editor" === t,
      l = r ? "silver" : E.finish,
      [o, p] = (0, a.useState)(!1),
      f = (0, a.useRef)(null),
      [v, y] = (0, a.useState)(!1),
      [w, N] = (0, a.useState)(!1),
      [P, L] = (0, a.useState)({ ...E, finish: l }),
      [$, R] = (0, a.useState)({}),
      [I, S] = (0, a.useState)(""),
      [C, A] = (0, a.useState)(!1),
      z = (0, a.useRef)(() => {}),
      F = (0, a.useRef)(!1);
    return (
      (0, a.useEffect)(() => {
        let e,
          t = f.current;
        if (!t) return;
        let n = !1,
          a = null,
          s = !1,
          i = !1,
          o = 0,
          v = 0,
          w = null,
          k = null,
          _ = null,
          E = null,
          P = { background: 0, finish: 0 },
          $ = document.documentElement.classList.contains("dark"),
          I = M($);
        (p($), L({ background: I.id, finish: l }));
        let C =
          (m++,
          (e = !1),
          () => {
            !e &&
              ((e = !0),
              --m > 0 ||
                queueMicrotask(() => {
                  0 === m &&
                    (function () {
                      let e = c;
                      ((c = null),
                        (d = null),
                        (u = null),
                        (h = null),
                        null == e || e.renderer.destroy(),
                        null == e || e.canvas.remove());
                    })();
                }));
          });
        function q() {
          if (!r || !k) return;
          ((k.deviceFinish = "silver"), (k.transparentBg = !1));
          let e = ($ ? 13 : 240) / 255;
          k.bgColor = [e, e, e];
        }
        function D(e) {
          if (!w || !k) return;
          w.renderer.setImage(e);
          let t = w.analyse(e);
          t && (k.extrudeColor = t.avg);
          let r = w.emission.sample(e);
          k.screenEmissionGrid = r ? Array.from(r) : void 0;
        }
        let O = t.clientWidth,
          W = t.clientHeight,
          T = { x: 0, y: 0 },
          B = { x: 0, y: 0 },
          H = matchMedia("(prefers-reduced-motion: reduce)"),
          U = matchMedia("(hover: hover) and (pointer: fine)"),
          X = null;
        function Y() {
          (cancelAnimationFrame(o), (o = 0), (v = 0));
        }
        function G(e) {
          if (((o = 0), n || !i || !s || document.hidden || !w || !k)) return;
          let t = v ? Math.min(e - v, 64) : 16.67;
          v = e;
          let r = H.matches ? 1 : 1 - Math.exp(-t / 95);
          ((T.x += (B.x - T.x) * r), (T.y += (B.y - T.y) * r));
          let a = 0.005 > Math.abs(B.x - T.x) && 0.005 > Math.abs(B.y - T.y);
          a && Object.assign(T, B);
          try {
            w.renderer.render(
              { ...k, tiltX: k.tiltX + T.x, tiltY: k.tiltY + T.y },
              Math.min(window.devicePixelRatio || 1, 2),
            );
          } catch (e) {
            x("render_failed", e);
            return;
          }
          a ? (v = 0) : (o = requestAnimationFrame(G));
        }
        function Z() {
          o || !i || !s || document.hidden || n || (o = requestAnimationFrame(G));
        }
        function J() {
          let e = !H.matches;
          (N(e),
            e
              ? i
                ? (y(!0), Z())
                : s && ea()
              : ((B.x = B.y = T.x = T.y = 0),
                Y(),
                i && s && !document.hidden && G(performance.now())));
        }
        function V(e) {
          if (
            !s ||
            document.hidden ||
            !(!H.matches && U.matches) ||
            "touch" === e.pointerType ||
            !w
          )
            return;
          let r = t.getBoundingClientRect();
          (Object.assign(
            B,
            w.tilt(
              ((e.clientX - r.left) / r.width) * 2 - 1,
              ((e.clientY - r.top) / r.height) * 2 - 1,
            ),
          ),
            Z());
        }
        function K(e) {
          var r, n;
          !H.matches &&
            "mouse" !== e.pointerType &&
            w &&
            ((null != (r = e.target) && r.closest("button")) ||
              ((X = { pointerId: e.pointerId, x: e.clientX, y: e.clientY, tiltX: B.x, tiltY: B.y }),
              null == (n = t.setPointerCapture) || n.call(t, e.pointerId)));
        }
        function Q(e) {
          if (!X || e.pointerId !== X.pointerId || !s || document.hidden) return;
          let r = t.getBoundingClientRect();
          ((B.x = Math.max(-14, Math.min(14, X.tiltX - ((e.clientY - X.y) / r.height) * 28))),
            (B.y = Math.max(-28, Math.min(28, X.tiltY + ((e.clientX - X.x) / r.width) * 56))),
            Z());
        }
        function ee(e) {
          var r;
          X &&
            e.pointerId === X.pointerId &&
            ((X = null),
            (null == (r = t.hasPointerCapture) ? void 0 : r.call(t, e.pointerId)) &&
              t.releasePointerCapture(e.pointerId));
        }
        function et(e) {
          if (H.matches) return;
          let t = { ArrowLeft: [0, -3], ArrowRight: [0, 3], ArrowUp: [-2, 0], ArrowDown: [2, 0] };
          if ("Home" === e.key || "Escape" === e.key) (e.preventDefault(), (B.x = B.y = 0), Z());
          else if (t[e.key]) {
            e.preventDefault();
            let [r, n] = t[e.key];
            ((B.x = Math.max(-7, Math.min(7, B.x + r))),
              (B.y = Math.max(-14, Math.min(14, B.y + n))),
              Z());
          }
        }
        function er() {
          ((i = !1),
            (w = null),
            Y(),
            y(!1),
            N(!1),
            A(!0),
            R({}),
            L({ background: I.id, finish: l }),
            S("Interactive preview unavailable. Showing the original scene."),
            g(en));
        }
        let en = {
          onLost(e) {
            n || ("taken" === e ? ((i = !1), Y(), y(!1), N(!1)) : er());
          },
        };
        function ea() {
          let e = arguments.length > 0 && void 0 !== arguments[0] && arguments[0];
          return n || (!e && H.matches) || i
            ? Promise.resolve()
            : a ||
                (a = (async () => {
                  try {
                    let e = t.querySelector("[data-scene-canvas]"),
                      a = await b(en, e);
                    if (n) return void g(en);
                    ((w = a),
                      k || ((k = a.createParams()), q()),
                      a.renderer.setCanvasCssSize(O, W));
                    let [s, l] = await Promise.all([
                      _ ?? a.loadImage(r ? "/hero-phone.jpg" : I.screen),
                      E ?? (r ? null : a.loadImage(I.file)),
                      a.renderer.prepareDeviceScreens(k),
                    ]);
                    if (n || u !== en) return;
                    ((_ = s),
                      (E = l),
                      D(s),
                      l ? a.renderer.setBgImage(l) : a.renderer.clearBgImage(),
                      (i = !0),
                      a.renderer.render(k, Math.min(window.devicePixelRatio || 1, 2)),
                      y(!0),
                      N(!H.matches),
                      Z());
                  } catch {
                    n || er();
                  } finally {
                    a = null;
                  }
                })());
        }
        z.current = async (e, t) => {
          let r = j[e].find((e) => e.id === t);
          if (!r) return;
          let a = ++P[e];
          (R((r) => ({ ...r, [e]: t })), S(""));
          try {
            if ((await ea(!0), n || a !== P[e] || !i || !w || !k)) return;
            if ("file" in r) {
              let [t, s] = await Promise.all([w.loadImage(r.file), w.loadImage(r.screen)]);
              if (n || a !== P[e] || !i || !w) return;
              ((E = t), (_ = s), w.renderer.setBgImage(t), D(s), (I = r));
            } else {
              if (
                (await w.renderer.prepareDeviceScreens({ ...k, deviceFinish: r.id }),
                n || a !== P[e] || !i || !w)
              )
                return;
              k.deviceFinish = r.id;
            }
            (L((r) => ({ ...r, [e]: t })), Z());
          } catch {
            n || a !== P[e] || S(`Couldn’t load ${r.label}. Please try that card again.`);
          } finally {
            n || a !== P[e] || R((t) => ({ ...t, [e]: void 0 }));
          }
        };
        let es = new MutationObserver(() => {
          let e = document.documentElement.classList.contains("dark");
          if (e === $) return;
          if ((($ = e), r)) {
            (p(e), q(), Z());
            return;
          }
          if (F.current) return;
          let t = M(e);
          ((I = t),
            (_ = null),
            (E = null),
            L((e) => ({ ...e, background: t.id })),
            (a || i) && z.current("background", t.id));
        });
        es.observe(document.documentElement, { attributes: !0, attributeFilter: ["class"] });
        let ei = new ResizeObserver((e) => {
          let [t] = e;
          ((O = t.contentRect.width),
            (W = t.contentRect.height),
            O > 0 && W > 0 && i && (null == w || w.renderer.setCanvasCssSize(O, W), Z()));
        });
        ei.observe(t);
        let el = new IntersectionObserver(
          (e) => {
            e[e.length - 1].isIntersecting && ea();
          },
          { rootMargin: "240px" },
        );
        el.observe(t);
        let eo = new IntersectionObserver((e) => {
          (s = e[e.length - 1].isIntersecting) ? Z() : Y();
        });
        eo.observe(t);
        let ec = () => {
          document.hidden ? Y() : Z();
        };
        return (
          document.addEventListener("visibilitychange", ec),
          document.addEventListener("pointermove", V, { passive: !0 }),
          t.addEventListener("pointerdown", K),
          t.addEventListener("pointermove", Q),
          t.addEventListener("pointerup", ee),
          t.addEventListener("pointercancel", ee),
          t.addEventListener("keydown", et),
          H.addEventListener("change", J),
          U.addEventListener("change", J),
          () => {
            ((n = !0),
              (z.current = () => {}),
              Y(),
              el.disconnect(),
              eo.disconnect(),
              ei.disconnect(),
              document.removeEventListener("visibilitychange", ec),
              document.removeEventListener("pointermove", V),
              t.removeEventListener("pointerdown", K),
              t.removeEventListener("pointermove", Q),
              t.removeEventListener("pointerup", ee),
              t.removeEventListener("pointercancel", ee),
              t.removeEventListener("keydown", et),
              H.removeEventListener("change", J),
              U.removeEventListener("change", J),
              es.disconnect(),
              g(en),
              C());
          }
        );
      }, [r, l]),
      (0, n.jsxs)("div", {
        className: r ? "h-full" : void 0,
        children: [
          (0, n.jsxs)("div", {
            className: r ? "relative h-full" : "relative",
            children: [
              (0, n.jsxs)("div", {
                ref: f,
                className: r
                  ? "relative h-full touch-pan-y overflow-hidden bg-[#f0f0f0] outline-none focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-[#FD6421] dark:bg-[#0d0d0d]"
                  : "squircle-lg relative touch-pan-y overflow-hidden bg-black outline-none before:block before:pt-[calc(76%+50px)] focus-visible:ring-2 focus-visible:ring-[#FD6421] focus-visible:ring-offset-4 sm:before:pt-[calc(56.25%+50px)]",
                tabIndex: w && v ? 0 : void 0,
                role: "group",
                "aria-label": w
                  ? "Interactive iPhone scene. Drag the scene, move your pointer, or use the arrow keys to rotate. Press Home to reset."
                  : r
                    ? "Silver iPhone preview."
                    : "iPhone scene. Choose a scene pairing or phone color.",
                "data-rock-scene": !0,
                "data-scene-variant": t,
                "data-ready": v,
                children: [
                  (0, n.jsx)(s.default, {
                    src: r
                      ? `/marketing/editor-scene/v1/silver-${o ? "dark" : "light"}.webp`
                      : `${k}/${P.background === _ ? "room-ultrahuman-poster" : "opal-poster"}.webp`,
                    alt: v
                      ? ""
                      : r
                        ? "A silver iPhone showing an app screen on a plain background"
                        : P.background === _
                          ? "An iPhone displaying Ultrahuman, lit in a bright room"
                          : "An iPhone displaying Opal, lit against a dark rocky landscape",
                    fill: !0,
                    sizes: "(max-width: 1180px) 100vw, 1100px",
                    className: "object-cover",
                  }),
                  (0, n.jsx)("div", {
                    "data-scene-canvas": !0,
                    className: `absolute inset-0 ${v ? "opacity-100" : "opacity-0"}`,
                  }),
                ],
              }),
              !r &&
                (0, n.jsxs)(n.Fragment, {
                  children: [
                    (0, n.jsxs)("fieldset", {
                      "data-scene-choices": !0,
                      disabled: C,
                      className:
                        "absolute right-2 top-1/2 m-0 min-w-0 -translate-y-1/2 border-0 p-0 sm:right-5",
                      children: [
                        (0, n.jsx)("legend", { className: "sr-only", children: "Scene pairing" }),
                        (0, n.jsx)("div", {
                          className: "flex flex-col items-center gap-1.5 sm:gap-2",
                          "aria-busy": !!$.background,
                          children: j.background.map((e) => {
                            let t = P.background === e.id,
                              r = $.background === e.id,
                              a = `${e.label} + ${e.app}`;
                            return (0, n.jsx)(
                              "button",
                              {
                                type: "button",
                                "aria-label": a,
                                "aria-pressed": t,
                                title: r ? `Loading ${a}…` : a,
                                onClick: () => {
                                  ((F.current = !0), z.current("background", e.id));
                                },
                                className: `um-glass flex size-7 items-center justify-center rounded-md border-0 sm:size-10 focus-visible:outline-2 focus-visible:outline-white focus-visible:outline-offset-4 disabled:cursor-not-allowed disabled:opacity-40 ${t ? "outline outline-1 outline-white/40 outline-offset-2" : "outline-none"} ${r ? "opacity-50" : "opacity-100"}`,
                                children: (0, n.jsx)("span", {
                                  className:
                                    "absolute inset-[3px] overflow-hidden rounded-[3px] bg-black",
                                  children: (0, n.jsx)(s.default, {
                                    src: `${k}/${e.file}-thumb.webp`,
                                    alt: "",
                                    fill: !0,
                                    sizes: "40px",
                                    className: "object-cover",
                                  }),
                                }),
                              },
                              e.id,
                            );
                          }),
                        }),
                      ],
                    }),
                    (0, n.jsxs)("fieldset", {
                      disabled: C,
                      className:
                        "absolute bottom-2 left-1/2 m-0 -translate-x-1/2 border-0 p-0 sm:bottom-4",
                      children: [
                        (0, n.jsx)("legend", { className: "sr-only", children: "Phone color" }),
                        (0, n.jsx)("div", {
                          className:
                            "um-glass um-glass-static flex items-center gap-1 rounded-full p-1 sm:p-1.5",
                          "aria-busy": !!$.finish,
                          children: j.finish.map((e) => {
                            let t = P.finish === e.id,
                              r = $.finish === e.id;
                            return (0, n.jsx)(
                              "button",
                              {
                                type: "button",
                                "aria-label": `${e.label} iPhone`,
                                "aria-pressed": t,
                                title: r ? `Loading ${e.label}…` : `${e.label} iPhone`,
                                onClick: () => z.current("finish", e.id),
                                className: `um-scene-swatch relative flex size-7 items-center justify-center rounded-full outline-none focus-visible:outline-2 focus-visible:outline-white/80 focus-visible:outline-offset-2 disabled:cursor-not-allowed disabled:opacity-40 sm:size-8 ${r ? "opacity-50" : "opacity-100"}`,
                                children: (0, n.jsx)("span", {
                                  className: `size-4 rounded-full shadow-[inset_0_1px_1px_rgba(255,255,255,0.3),inset_0_-1px_1px_rgba(0,0,0,0.3)] sm:size-5 ${t ? "outline outline-1 outline-white/55 outline-offset-[3px]" : ""}`,
                                  style: { backgroundColor: e.color },
                                }),
                              },
                              e.id,
                            );
                          }),
                        }),
                      ],
                    }),
                  ],
                }),
            ],
          }),
          (0, n.jsx)("p", {
            role: "status",
            className: I ? `${i.EC} mt-3 text-[12px] text-zinc-500 dark:text-zinc-400` : "sr-only",
            children: I || (Object.values($).some(Boolean) ? "Loading your scene…" : ""),
          }),
        ],
      })
    );
  }
}
